export enum AllergenType {
  AllergenTrace = 'trace',
  AllergenFree = 'free',
  SpicyLevel = 'spicy',
}
